import { productionTransactionIsValid } from "services/sosInventoryService/productionTransaction/isValid";
import { quantitySerialsIsValid } from "services/utility/isValid";
import { isFinishedGoods } from "services/utility/jobWorkCenter";

export function isValid(record, __, ___, outputs, inputs) {
  let errors = productionTransactionIsValid(record, outputs, inputs);

  // Only validate serial numbers if the work center is "Finished Goods".
  // If the work center is not "Finished Goods", serials are not required regardless of auto-numbering.
  if (isFinishedGoods(record.workcenter)) {
    errors = quantitySerialsIsValid(
      errors,
      outputs,
      record.autoSerialLotNumbering,
      "output"
    );
  }

  errors = quantitySerialsIsValid(
    errors,
    inputs,
    record.autoSerialLotNumbering,
    "input"
  );
  return errors;
}
